export interface TravellerDisplayInput {
    title: string
    firstName: string
    lastName: string
}

export interface TravellerDisplayOutput {
    displayName: string
    initials: string
}

export function buildTravellerDisplay(input: TravellerDisplayInput): TravellerDisplayOutput {
    const displayName = input.firstName ? `${input.title ? `${input.title}.` : ''}${input.firstName} ${input.lastName}`.replace(/\s+/g, ' ').trim() : "--"
    const initials = `${input.firstName?.[0] || ''}${input.lastName?.[0] || ''}`.toUpperCase()

    return { displayName, initials }
}

